import { useRef } from 'react'
import { patterns } from '../utils'

import UP from '../images/dra_02.png'
import DOWN from '../images/pua_02.png'
import KEEP from '../images/gda_02.png'

export default function useCustomSma(chart, isDrawSection) {
  const clickCount = useRef(0)
  const sectionStartX = useRef()
  const sectionIds = useRef([])
  const arrowPoints = useRef([])

  function start(e) {
    if (!isDrawSection.current) return

    const mainSeries = this.get('main')
    const mainXaxisSeries = this.get('main-xaxis')
    const iconsSeries = this.get('custom-sma-icons')

    if (clickCount.current === 0) {
      clickCount.current++
      sectionStartX.current = Math.floor(e.xAxis[0].value)
    } else if (clickCount.current === 1) {
      clickCount.current = 0

      // draw band
      const clickedStartX = sectionStartX.current
      const clickedEndX = Math.ceil(e.xAxis[0].value)
      const length = Math.min(
        Math.max(Math.abs(clickedEndX - clickedStartX) + 1, 5),
        180
      )
      const startX = Math.min(clickedStartX, clickedEndX)
      const endX = startX + length - 1

      patterns
        .getPlotBands(
          Array(length)
            .fill(null)
            .map((_, idx) => {
              return startX + idx
            }),
          [],
          'rgba(100, 200, 120, 0.2)',
          'rgba(0,0,0,0)',
          'predict'
        )
        .forEach((plotBand) => {
          mainXaxisSeries.addPlotBand(plotBand, false)
          sectionIds.current = [...sectionIds.current, plotBand.id]
        })

      // n일선 계산
      let className = ''
      const beforeNthDayAveragePrice = (() => {
        const _startX = Math.max(startX - length, 0)
        const _length = startX - _startX

        const sum = Array(startX - _startX)
          .fill(null)
          .reduce(
            (prev, _, idx) => mainSeries.yData[_startX + idx][3] + (prev || 0),
            0
          )

        return sum / _length
      })()
      const standardDayAveragePrice = (() => {
        const sum = Array(length)
          .fill(null)
          .reduce(
            (prev, _, idx) => mainSeries.yData[startX + idx][3] + (prev || 0),
            0
          )

        return sum / length
      })()
      if (standardDayAveragePrice >= beforeNthDayAveragePrice * 1.01) {
        className = UP
      } else if (
        beforeNthDayAveragePrice * 1.01 > standardDayAveragePrice &&
        standardDayAveragePrice > beforeNthDayAveragePrice * 0.99
      ) {
        className = KEEP
      } else {
        className = DOWN
      }

      // 아이콘 표기
      const point = {
        x: endX + 1,
        y: mainSeries.yData[endX + 1][1],
        marker: {
          symbol: `url(${className})`,
          width: 34,
          height: 136,
        },
      }

      iconsSeries.addPoint(point, false, false)
      iconsSeries.show()
      arrowPoints.current = [...arrowPoints.current, point]
    }
  }

  function removePrev() {
    if (!chart) return

    const mainXaxisSeries = chart.get('main-xaxis')
    const iconsSeries = chart.get('custom-sma-icons')

    mainXaxisSeries.removePlotBand(sectionIds.current.pop())
    arrowPoints.current.pop()
    iconsSeries.setData(arrowPoints.current)
    iconsSeries.show()
  }

  function removeAll() {
    if (!chart) return

    const mainXaxisSeries = chart.get('main-xaxis')
    const iconsSeries = chart.get('custom-sma-icons')
    sectionIds.current.map((id) => mainXaxisSeries.removePlotBand(id))
    iconsSeries.setData([])
    sectionIds.current = []
    arrowPoints.current = []
  }

  return {
    start,
    removePrev,
    removeAll,
  }
}
